import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { FormField } from '@nuso/forms/data-access';
import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-slide-toggle-input',
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.css'],
    standalone: false
})
export class SlideToggleComponent extends BaseFormInput {
  @Input() override field: FormField;

}
